<!-- ProfilePage.vue -->
<template>
  <div class="profile-container">
    <h1>User Profile</h1>
    <form @submit.prevent="updateProfile">
      <div class="form-group">
        <label for="firstName">First Name:</label>
        <input
          id="firstName"
          v-model="profile.firstName"
          type="text"
          required
        >
      </div>

      <div class="form-group">
        <label for="lastName">Last Name:</label>
        <input
          id="lastName"
          v-model="profile.lastName"
          type="text"
          required
        >
      </div>

      <div class="form-group">
        <label for="email">Email:</label>
        <input
          id="email"
          v-model="profile.email"
          type="email"
          disabled
        >
      </div>

      <div class="form-group">
        <label for="currentPassword">Current Password:</label>
        <input
          id="currentPassword"
          v-model="passwords.currentPassword"
          type="password"
        >
      </div>

      <div class="form-group">
        <label for="newPassword">New Password:</label>
        <input
          id="newPassword"
          v-model="passwords.newPassword"
          type="password"
        >
      </div>

      <button type="submit">
        Save Changes
      </button>
    </form>

    <p
      v-if="message"
      :class="{'success': success, 'error': !success}"
    >
      {{ message }}
    </p>
  </div>
  <div class="profile-footer">
    <button
      class="back-button"
      @click="navigateBack"
    >
      Finished
    </button>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProfilePage',
  data() {
    return {
      profile: {
        firstName: '',
        lastName: '',
        email: '',
      },
      passwords: {
        currentPassword: '',
        newPassword: '',
      },
      message: '',
      success: false,
    };
  },
  created() {
    this.fetchProfile();
  },
  methods: {
    async fetchProfile() {
      try {
        const response = await axios.get('https://api.inventory.stafftraining.me/api/user/profile', {
          headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
        });
        if (response.data.success) {
          this.profile = response.data.data;
        } else {
          this.message = 'Failed to fetch profile details.';
          this.success = false;
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
        this.message = 'An error occurred while fetching profile.';
        this.success = false;
      }
    },
    async updateProfile() {
      try {
        const payload = {
          firstName: this.profile.firstName,
          lastName: this.profile.lastName,
          currentPassword: this.passwords.currentPassword,
          newPassword: this.passwords.newPassword,
        };

        const response = await axios.post(
          'https://api.inventory.stafftraining.me/api/user/profile/update',
          payload,
          { headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` } },
        );

        this.message = response.data.message;
        this.success = response.data.success;

        if (this.success) {
          this.passwords.currentPassword = '';
          this.passwords.newPassword = '';
        }
      } catch (error) {
        console.error('Error updating profile:', error);
        this.message = error.response?.data?.message || 'An error occurred while updating profile.';
        this.success = false;
      }
    },
    navigateBack() {
      this.$router.go(-1); // Navigate to the previous page
    },
  },
};
</script>

  <style scoped>
  .profile-container {
    width: 300px;
    margin: 30px auto;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  h1 {
    text-align: center;
    margin-bottom: 20px;
  }

  .form-group {
    margin-bottom: 15px;
  }

  label {
    display: block;
    margin-bottom: 5px;
  }

  input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  button {
    width: 100%;
    padding: 10px;
    background-color: #00A3DB;
    color: white;
    border: none;
    border-radius: 12px;
    cursor: pointer;
  }

  button:hover {
    background-color: #007BA7;
  }

  .success {
    color: green;
  }

  .error {
    color: red;
  }

  .profile-footer {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

/* Back button style */
.back-button {
  background-color: #00A3DB;
  color: white;
  border: none;
  width: 280px;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 12px;
  font-size: 14px;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: #2980b9; /* Darker blue on hover */
}
  </style>
